module.exports = __webpack_public_path__ + "img/refer4.png";